<div class="spinner" [style.backgroundColor]="bg" [style.height]="heightPage">
  <div>
    <mat-spinner></mat-spinner>
    <p>Carregando</p>
  </div>
</div>